import { render, staticRenderFns } from "./SaleTaxTargetSelect.vue?vue&type=template&id=6cf5f0b8&lang=pug"
import script from "./SaleTaxTargetSelect.vue?vue&type=script&lang=js"
export * from "./SaleTaxTargetSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports